import { useEffect, useState } from "react";
import { ServiceApi } from "../../services/index.service";
import { enqueueSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { checkForCorporateUser } from "../ProductionSheet";
import { emailValidator, mobileValidator } from "../../utils";
import { VENDOR_PORTAL_TOUR_STEPS } from "../../utils/tourConstants";
import { continuousTour, runTour, showTourProgress, updateSteps } from "../../redux/userOnboarding/userOnboardingSlice";

const initialDialog = {
  manageVendor: false,
  addfields: false,
  delete: false,
};
const initialValues = {
  intVendorGatewayID: 0,
  vchVendorName: "",
  vchVendorDescription: "",
  fields: [],
  vchVendorURL: "",
  images: [],
  vchPost: "GET",
  vchVendorImage: "",
  vchEmail: "",
  vchPhoneNumber: "",
  vchCategory: "",
};
const useOnlineVendorOrdering = () => {
  const dispatch = useDispatch();
  const serviceapi = new ServiceApi();
  const [loading, setLoading] = useState(true);
  const [btnLoading, setBtnLoading] = useState(false);
  const [showDialog, setShowDialog] = useState(initialDialog);
  const [isEdit, setIsEdit] = useState(false);
  const [modified, setModified] = useState(false);
  const [selectedItem, setSelectedItem] = useState(initialValues);
  const { profile, storage, userOnboarding } = useSelector((state) => state);
  const [store, setStore] = useState(null);
  const handleToggleDialog = (name, value) => {
    setShowDialog({ ...showDialog, [name]: value });
  };
  const handleCloseDialog = () => {
    setShowDialog(initialDialog);
    setSelectedItem(initialValues);
    setIsEdit(false);
    setModified(false);
    fetchVendors();
  };
  const [vendorsList, setVendorsList] = useState([]);
  useEffect(() => {
    if (store?.intStoreID) {
      fetchVendors(store?.intStoreID);
    }
  }, [store]);

  useEffect(() => {
    setStore(storage?.store);
  }, [storage?.store]);


  useEffect(() => {
    if (!userOnboarding?.tourStatus?.vendorPortal && store) {
      startVendorPortalTour();
   }
  }, [store, vendorsList, userOnboarding?.tourStatus?.vendorPortal]);

  const startVendorPortalTour = () => {
    dispatch(updateSteps(VENDOR_PORTAL_TOUR_STEPS));
    dispatch(continuousTour());
    dispatch(showTourProgress());
    dispatch(runTour("vendorPortal"));
  }


  const handleEdit = (dataItem) => {
    setSelectedItem({ ...dataItem, images: [dataItem?.vchVendorImage] });
    setIsEdit(true);
    handleToggleDialog("manageVendor", true);
  };
  const handleAddFields = (dataItem) => {
    setSelectedItem(dataItem);
    handleToggleDialog("addfields", true);
  };
  const handleDelete = (dataItem) => {
    setSelectedItem(dataItem);
    handleToggleDialog("delete", true);
  };

  const fetchVendors = async (storeId = storage?.store?.intStoreID) => {
    const intStoreID = storeId;
    setLoading(true);
    const vendors = await serviceapi.fetchOnlineVendorsList(intStoreID);
    setLoading(false);
    setVendorsList(vendors?.data);
  };

  const handleChange = (value, name) => {
    setSelectedItem({ ...selectedItem, [name]: value });
  };

  const handleImage = (dataItem) => {
    setSelectedItem({ ...selectedItem, images: dataItem });
  };
  const handleValdiation = () => {
    if (
      !selectedItem?.vchVendorName ||
      !selectedItem?.vchVendorURL ||
      !selectedItem?.vchVendorDescription ||
      !selectedItem?.vchPost ||
      selectedItem?.images?.length === 0 ||
      !selectedItem?.vchCategory || selectedItem?.vchCategory==="Please Select Category" ||
      emailValidator(selectedItem?.vchEmail) || (selectedItem?.vchPhoneNumber && mobileValidator(selectedItem?.vchPhoneNumber))
    ) {
      return false;
    }
    return true;
  };

  const handleConfirmDelete = async () => {
    const res = await serviceapi?.deleteOnlineVendor(
      selectedItem?.intVendorGatewayID
    );
    handleCloseDialog();
    
  };
  const handleSubmit = async () => {
    setModified(true);
    const check = handleValdiation();
    if (!check) {
      return;
    }
    if (isEdit) {
      const req = {
        vchVendorName: selectedItem?.vchVendorName,
        vchVendorDescription: selectedItem?.vchVendorDescription,
        vchvendorImageURL:selectedItem?.images[0]?.base64_data ? undefined : selectedItem?.images[0],
        vchVendorImage:
          selectedItem?.images[0]?.base64_data ? selectedItem?.images[0]?.base64_data : undefined,
        vchVendorURL: selectedItem?.vchVendorURL,
        vchPost: selectedItem?.vchPost,
        action: "edit",
        intVendorGatewayID: selectedItem?.intVendorGatewayID,
        vchPhoneNumber: selectedItem?.vchPhoneNumber,
        vchEmail: selectedItem?.vchEmail,
        vchCategory: selectedItem?.vchCategory,
      };
      setBtnLoading(true)
      const res = await serviceapi.saveOrUpdateOnlineVendor(req);
      setBtnLoading(false)
      if (res?.statusCode === 201) {
        enqueueSnackbar("Online Vendor updated successfully", {
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "success",
        });
        handleCloseDialog();
      } else {
        enqueueSnackbar("Error in updating online vendor", {
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        });
      }
    } else {
      const req = {
        vchVendorName: selectedItem?.vchVendorName,
        vchVendorDescription: selectedItem?.vchVendorDescription,
        vchVendorImage: selectedItem?.images[0]?.base64_data,
        vchVendorURL: selectedItem?.vchVendorURL,
        vchPost: selectedItem?.vchPost,
        action: "add",
        vchPhoneNumber: selectedItem?.vchPhoneNumber,
        vchEmail: selectedItem?.vchEmail,
        vchCategory: selectedItem?.vchCategory,
      };
      setBtnLoading(true)
      const res = await serviceapi.saveOrUpdateOnlineVendor(req);
      setBtnLoading(false)
      if (res?.statusCode === 201) {
        enqueueSnackbar("Online Vendor created successfully", {
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "success",
        });
        handleCloseDialog();
      } else {
        enqueueSnackbar("Error in creating online vendor", {
          anchorOrigin: { vertical: "top", horizontal: "right" },
          variant: "error",
        });
      }
    }
  };


    const isAdmin= !checkForCorporateUser(profile?.role) ? true : false

  return {
    loading,
    vendorsList,
    handleToggleDialog,
    showDialog,
    handleCloseDialog,
    isEdit,
    handleEdit,
    handleChange,
    selectedItem,
    modified,
    handleSubmit,
    handleDelete,
    handleImage,
    handleConfirmDelete,
    handleAddFields,
    store,
    btnLoading,
    isAdmin
  };
};

export default useOnlineVendorOrdering;
